/* eslint-disable react/prop-types */
import {
  Box,
  Grid,
  darken,
  Alert,
  TextField,
  Autocomplete,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import SelectCustomer from "components/SelectCustomer";
import { setHomePage, useMaterialUIController } from "context";
import dayjs from "dayjs";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import { useEffect, useMemo, useRef, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { API_ROUTES, CODE_QUANGNAM } from "../../utils/constants";
import CustomerTableStatic from "components/CustomerTableStatic";
import { useSetRecoilState } from "recoil";
import { AlertState } from "states";
const ALLVALUE = { ma: "ALL", ten: "Tất cả" };

function QuanLyGiayPhep() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const _timeOut = useRef();
  const [tableData, setTableData] = useState({});
  const axiosPrivateInstance = useAxiosPrivate();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [optionNhomSanPham, setOptionNhomSanPham] = useState([]);
  const [optionSanPham, setOptionSanPham] = useState([]);
  const [optionSelectSanPham, setOptionSelectSanPham] = useState([]);
  const [optionDistrict, setOptionDistrict] = useState([]);
  const [optionSubDitrict, setOptionSubDitrict] = useState([]);
  const [errors, setErrors] = useState();

  const setAlert = useSetRecoilState(AlertState);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [paramsState, setParamsState] = useState({
    nam: null,
    nhomsanpham: ALLVALUE.ma,
    maquan: ALLVALUE.ma,
    hang: ALLVALUE.ma,
  });
  const [cloneDataAll, setCloneDataALL] = useState([]);
  useEffect(() => {
    const fetchDataHuyen = async (codeProvince) => {
      try {
        const response = await axiosPrivateInstance.get(API_ROUTES.GETHUYEN, {
          params: { tinh: codeProvince },
        });
        setOptionDistrict(response?.data);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    const fetchDataDataNhomSanPham = async () => {
      try {
        const response = await axiosPrivateInstance.get("nhomsanpham");
        setOptionNhomSanPham(response.data["data"]);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    fetchDataHuyen(CODE_QUANGNAM);
    fetchDataDataNhomSanPham();
  }, []);

  // Lấy toàn bộ dữ liệu
  const fetchData = async (
    { nam, nhomsanpham, maquan, maphuong, hang },
    { pageIndex, pageSize }
  ) => {
    if (!tableData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      let body = {
        nam: nam && dayjs(nam)?.isValid() ? dayjs(nam)?.get("year") : undefined,
        nhomsanpham: nhomsanpham == ALLVALUE.ma ? undefined : nhomsanpham,
        maquan: maquan == ALLVALUE.ma ? undefined : maquan,
        maphuong: maphuong == ALLVALUE.ma ? undefined : maphuong,
        hang: hang == ALLVALUE.ma ? undefined : hang,
        pageNumber: pageIndex + 1,
        countNumber: pageSize,
      };
      const response = await axiosPrivateInstance.get(API_ROUTES.CHAMDIEM, {
        params: body,
      });
      setRowCount(response.data?.totalRecord);
      setTableData(response.data?.data);
    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  useEffect(() => {
    _timeOut.current && clearTimeout(_timeOut.current);
    _timeOut.current = setTimeout(() => {
      fetchData(paramsState, pagination);
    }, [200]);
  }, [paramsState, pagination]);

  useEffect(() => {
    const fetchDataCloneAll = async (
      nam,
      nhomsanpham,
      maquan,
      maphuong,
      hang
    ) => {
      try {
        let body = {
          nam:
            nam && dayjs(nam)?.isValid() ? dayjs(nam)?.get("year") : undefined,
          nhomsanpham: nhomsanpham == ALLVALUE.ma ? undefined : nhomsanpham,
          maquan: maquan == ALLVALUE.ma ? undefined : maquan,
          maphuong: maphuong == ALLVALUE.ma ? undefined : maphuong,
          hang: hang == ALLVALUE.ma ? undefined : hang,
        };
        const response = await axiosPrivateInstance.get(API_ROUTES.CHAMDIEM, {
          params: body,
        });
        const validatedData = validateObjectDuan(response.data.data);
        setCloneDataALL(validatedData);
      } catch (error) {
        setAlert({
          alert: true,
          message: error?.message || "Lỗi!",
          type: "error",
        });
        console.log(error);
        return;
      }
    };
    fetchDataCloneAll(paramsState);
  }, [paramsState]);

  const validateObjectDuan = (rawData) => {
    const dataFiltered = rawData?.map((item) => {
      let dataEachItem = { ...item };
      if (item?.ngay) {
        const value = item?.ngay;
        dataEachItem["ngaycongnhan_format"] =
          value && dayjs(value).isValid()
            ? dayjs(value).format("DD/MM/YYYY")
            : value;
      }
      return { ...dataEachItem };
    });
    return dataFiltered;
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: true,
        enableColumnActions: false,
      },
      {
        accessorKey: "phieudangky_noidung",
        header: "Phiếu đăng ký",
        size: 120,
      },
      {
        accessorKey: "sanpham_ten",
        header: "Sản phẩm",
        size: 150,
      },
      {
        accessorKey: "noidung",
        header: "Nội dung",
      },
      {
        accessorKey: "soquyetdinh",
        header: "Số quyết định",
        size: 150,
      },
      {
        accessorKey: "ngay",
        header: "Ngày công nhận",
        size: 120,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value && dayjs(value).isValid()
            ? dayjs(value).format("DD/MM/YYYY")
            : "";
        },
      },
      {
        accessorKey: "hang",
        header: "Hạng",
        size: 90,
      },
    ],
    []
  );

  //lấy data sản phẩm theo nhóm sản phẩm
  const fetchDataDataSanPhamByNhom = async (nhom) => {
    try {
      const response = await axiosPrivateInstance.get(API_ROUTES.SANPHAM, {
        params: { nhomsanpham: nhom },
      });
      const data = response.data?.["data"];
      let list = [{ id: "ALL", ten: "Tất cả" }];
      if (data?.length > 0) {
        list = [...list, ...data];
      }
      setOptionSelectSanPham(list);
    } catch (error) {
      console.log(error);
      return;
    }
  };
  //nam
  const handleChangeDate = (value) => {
    setParamsState((prev) => {
      return {
        ...prev,
        nam: value,
      };
    });
  };
  const handleToClearDate = () => {
    setParamsState((prev) => ({
      ...prev,
      nam: null,
    }));
  };
  //nhomsanpham
  const handleChangeNhomSanPham = (e) => {
    let { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      nhomsanpham: value,
      sanpham: ALLVALUE.ma,
    }));
    if (value !== ALLVALUE.ma) {
      fetchDataDataSanPhamByNhom(value);
    } else {
      setOptionSelectSanPham(optionSanPham);
    }
  };
  const handleChangeAutoComplete = (key) => (e, newValue) => {
    setParamsState((prev) => ({
      ...prev,
      [key]: newValue ? newValue.id : ALLVALUE.ma,
    }));
  };
  const handleChangeDistrict = (e) => {
    let { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      maquan: value,
      maphuong: ALLVALUE.ma,
    }));
    getSubditrict(value);
  };
  const getSubditrict = (code) => {
    axiosPrivateInstance
      .get(API_ROUTES.GETXA, { params: { huyen: code } })
      .then((res) => {
        setOptionSubDitrict(res?.data);
      })
      .catch(() => {});
  };
  const handleChangeHang = (e) => {
    const { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      hang: value,
    }));
  };
  const handleChangeState = (e) => {
    let { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      maphuong: value,
    }));
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        pt={6}
        py={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.5rem",
          px: 3,
        }}
      >
        <Box>
          {errors && errors.error ? (
            <Grid container sx={{ textAlign: "center", mb: 0 }}>
              <Grid item xs={12}>
                <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                  {errors.error}
                </Alert>
              </Grid>
            </Grid>
          ) : (
            ""
          )}
        </Box>
        <Grid
          container
          spacing={2}
          rowSpacing={2}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid item xs={12} md={2} lg={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={paramsState?.nam ? dayjs(paramsState.nam) : null}
                views={["year"]}
                onChange={handleChangeDate}
                slotProps={{
                  textField: {
                    InputLabelProps: { shrink: true },
                    placeholder: "---Chọn năm---",
                    fullWidth: true,
                    inputProps: {
                      readOnly: true,
                    },
                  },
                  field: {
                    clearable: true,
                    onClear: handleToClearDate,
                  },
                }}
                label="Năm"
                sx={{
                  ".MuiInputLabel-shrink": {
                    fontSize: "0.875rem",
                    lineHeight: "1.6",
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <SelectCustomer
              keyValue="nhomsanpham"
              label="Nhóm sản phẩm"
              labelName="ten"
              option={optionNhomSanPham}
              onChange={handleChangeNhomSanPham}
              state={paramsState.nhomsanpham}
              unicode="id"
            />
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <Autocomplete
              sx={{
                ".MuiAutocomplete-input": {
                  padding: "7px 4px 7px 16px !important",
                },
              }}
              id="combo-box-sanPham"
              options={optionSelectSanPham}
              getOptionLabel={(option) => option.ten}
              value={
                optionSelectSanPham?.find(
                  (option) => option.id === paramsState.sanpham
                ) || null
              }
              onChange={handleChangeAutoComplete("sanpham")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Sản phẩm"
                  placeholder="Chọn sản phẩm"
                  disabled={optionSanPham?.length > 0 ? false : true}
                />
              )}
              renderOption={(props, options) => (
                <Box component="li" {...props} key={options.id}>
                  {options.ten}
                </Box>
              )}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={8} md={2} lg={2}>
            <SelectCustomer
              keyValue="hang"
              label="Hạng"
              labelName="ten"
              option={[
                { id: 1, ten: "Hạng 1" },
                { id: 2, ten: "Hạng 2" },
                { id: 3, ten: "Hạng 3" },
                { id: 4, ten: "Hạng 4" },
                { id: 5, ten: "Hạng 5" },
              ]}
              onChange={handleChangeHang}
              state={paramsState.hang}
              unicode="id"
            />
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <SelectCustomer
              keyValue="maquan"
              label="Quận/Huyện"
              labelName="ten"
              option={optionDistrict}
              onChange={handleChangeDistrict}
              state={paramsState.maquan}
              unicode="ma"
            />
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <SelectCustomer
              keyValue="maphuong"
              label="Phường xã"
              labelName="ten"
              option={optionSubDitrict}
              onChange={handleChangeState}
              state={paramsState.maphuong}
              unicode="ma"
            />
          </Grid>
        </Grid>
      </MDBox>
      <MDBox py={3}>
        <CustomerTableStatic
          columns={columns}
          data={tableData}
          allData={cloneDataAll}
          isUsingAllData={true}
          isLoading={isLoading}
          isError={isError}
          setPagination={setPagination}
          pagination={pagination}
          isRefetching={isRefetching}
          tableHeaders={[
            "Phiếu đăng ký",
            "Sản phẩm",
            "Nội dung",
            "Số quyết định",
            "Ngày công nhận",
          ]}
          tableKeyValues={[
            "phieudangky_noidung",
            "sanpham_ten",
            "noidung",
            "soquyetdinh",
            "ngaycongnhan_format",
          ]}
          filename={"GiayChungNhan"}
          titleTable={"Giấy chứng nhận sản phẩm OCOP"}
          colWidths={[5, 20, 20, 25, 15, 15]}
          widthPercentPDF={[25, 25, 21, 12, 12]}
          count={rowCount}
          orientaitionPage={"landscape"}
        />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default QuanLyGiayPhep;
